import { CloseOutlined, PlusCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import { Drawer, Modal } from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import './style.css';
import AnimatedTextField from 'components/AnimatedTextField';
import AnimatedDatePicker from 'components/AnimatedDatePicker';
import moment from "moment";
import AnimatedTimePicker from 'components/AnimatedTimePicker';
import AnimatedCustomSelect from 'components/AnimatedSelectComp';
import { connect } from 'react-redux';
import { getAutocompleteCourses } from 'actions/courseManagement';
import { Button } from 'components/Button';
import { checkBatchNameAvailability, getAllClasses, getCourseData, getSubjStudentsData, postAddClassV2, postAddClassWithImport, storeSectionId } from 'actions/classRoom';
import { Notification } from 'services';
import BatchDeleteModal from './batchDeleteModal';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import chevronLeft from "../../../Assets/classroom/close-chevron.svg";
import chevronDown from "../../../Assets/classroom/open-chevron.svg";
import moveIcon from "../../../Assets/classroom/moveIcon.svg";
import Xmark from "../../../Assets/common/Xmark.svg";
import enabledMove from "../../../Assets/classroom/three-dots-vertical.svg";
import disabledMove from "../../../Assets/classroom/three-dots-vertical2.svg";

const ItemType = 'SECTION';
const DraggableSection = ({ section, index, moveSection, children, sections }) => {

    // Check if any section is expanded
    const isAnySectionExpanded = sections.some(section => section.isExpanded);

    // Determine if dragging should be disabled
    const isDragDisabled = sections.length === 1 || isAnySectionExpanded;

    const ref = useRef(null);

    const [{ isDragging }, drag] = useDrag({
        type: ItemType,
        item: { index },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        canDrag: !isDragDisabled
    });

    const [, drop] = useDrop({
        accept: ItemType,
        hover: (draggedItem, monitor) => {
            if (isDragDisabled || !ref.current) {
                return;
            }

            const dragIndex = draggedItem.index;
            const hoverIndex = index;

            if (dragIndex === hoverIndex) {
                return;
            }

            moveSection(dragIndex, hoverIndex);
            draggedItem.index = hoverIndex;
        },
    });

    drag(drop(ref));

    return (
        <div
            ref={ref}
            style={{
                opacity: isDragging ? 0.5 : 1,
                backgroundColor: '#fff'
            }}
        >
            {children}
        </div>
    );
};
const EditBatchDrawer = ({ editBatchModal, createBatchDrawer, onClose, fromCourseDetails, postAddClassWithImport, selectedClassDetails, newCourseId, isFromCourseDetailsReducer,
    autocompleteCoursesSearchData, getAutocompleteCourses, postAddClassV2, getAllClasses, addSectionDrawer, addCourseDrawer, editBatchModal1, addSectionDrawer1, createBatchDrawer1,
    getSubjStudentsData, getCourseData, storeSectionId, isInsideSingleClass, setIsBatchesExpandClicked, checkBatchNameAvailability, specificCourseDataContainer }) => {
    const history = useHistory();
    const [className, setClassName] = useState('');
    // A section already saved under this batch name, or null when the name is free.
    const [nameClash, setNameClash] = useState(null);
    // every section of the existing batch the typed name matches, to find the ones without a course
    const [nameClashSections, setNameClashSections] = useState([]);
    const [checkingName, setCheckingName] = useState(false);
    const nameCheckId = useRef(0);
    const [addClassLoader, setAddClassLoader] = useState(false);
    const [showConfirmDeleteModal, setConfirmDeleteModal] = useState(false);
    const [sections, setSections] = useState([{
        id: '',
        index: 1,
        name: '',
        startDate: '',
        endDate: '',
        startTime: '',
        endTime: '',
        repeat: null,
        strength: 0,
        stopAdmission: true,
        isExpanded: true,
        courseId: null,
        courseType: '',
        curriculum: false,
        selectedDays: new Set(),
        studentsCount: 0,
        alreadyImported: null
    }]);
    const days = [
        { label: "S", value: '1' },
        { label: "M", value: '2' },
        { label: "T", value: '3' },
        { label: "W", value: '4' },
        { label: "T", value: '5' },
        { label: "F", value: '6' },
        { label: "S", value: '7' },
    ];

    const addSection = () => {
        // Collapse all existing sections
        const collapsedSections = sections.map(section => ({
            ...section,
            isExpanded: false
        }));
        // Add new section that is expanded with fresh empty selectedDays
        setSections([
            ...collapsedSections,
            {
                id: '',
                index: sections.length + 1,
                name: '',
                startDate: '',
                endDate: '',
                startTime: '',
                endTime: '',
                repeat: null,
                strength: 0,
                stopAdmission: true,
                isExpanded: true,
                // The course is shared across sections, so a new one starts on it too.
                courseId: sections?.[0]?.courseId ?? null,
                courseType: sections?.[0]?.courseType ?? '',
                curriculum: false,
                selectedDays: new Set(),  // Fresh empty Set for new section
                studentsCount: 0,
                alreadyImported: null

            }
        ]);
    };

    // only courses that have a curriculum, i.e. at least one chapter (a subject with zero chapters does not count)
    const filteredCourses = autocompleteCoursesSearchData.filter(item => item.itemType === 'course' && parseInt(item.chapterCount) > 0);

    // Sections hold the autocomplete list's `id`; the server wants the underlying `itemId`.
    const resolveCourseId = (sectionCourseId) => {
        // Unfiltered list: a saved section may point at a course with no curriculum.
        const matchedCourse = autocompleteCoursesSearchData.find(course => course.id === sectionCourseId);
        return !fromCourseDetails
            ? matchedCourse ? matchedCourse?.itemId : sectionCourseId
            : isInsideSingleClass ? matchedCourse?.itemId : newCourseId;
    };

    // Only a new batch takes a name typed by hand; the other flows work off a batch already chosen.
    const isCreatingNewBatch = !!(createBatchDrawer || createBatchDrawer1);

    // A new batch cannot reuse an existing name: batches are grouped by name alone, so the two would
    // merge into one entry.
    useEffect(() => {
        const name = (className || '').trim();
        if (!isCreatingNewBatch || !name) {
            nameCheckId.current += 1; // drop any in-flight response
            setNameClash(null);
            setCheckingName(false);
            return;
        }
        const requestId = ++nameCheckId.current;
        setCheckingName(true);
        const timer = setTimeout(() => {
            checkBatchNameAvailability(name, (batches) => {
                if (requestId !== nameCheckId.current) {
                    return; // a newer check has since been fired
                }
                setCheckingName(false);
                if (!batches) {
                    // Lookup failed: let the submit response report it instead.
                    setNameClash(null);
                    setNameClashSections([]);
                    return;
                }
                // LIKE search, so pick the exact name (case insensitive server-side).
                const matchedName = Object.keys(batches).find(batch => batch?.trim()?.toLowerCase() === name.toLowerCase());
                // not every section carries a course, so prefer one that does
                const matchedSections = matchedName ? (batches[matchedName] || []) : [];
                setNameClash(matchedSections.find(section => section?.courseId) || matchedSections[0] || null);
                setNameClashSections(matchedSections);
            });
        }, 400);
        return () => clearTimeout(timer);
    }, [className, isCreatingNewBatch]);

    // Reusing an existing batch name turns this into "add a section to that batch", so the new section
    // has to sit on that batch's own course rather than one picked here.
    const isJoiningExistingBatch = isCreatingNewBatch && !!nameClash;
    const courseCameFromClash = useRef(false);
    useEffect(() => {
        if (isJoiningExistingBatch) {
            const batchCourse = autocompleteCoursesSearchData.find(course => course.itemId == nameClash?.courseId);
            if (!batchCourse) {
                return;
            }
            courseCameFromClash.current = true;
            setSections(prevSections => prevSections.map(section => ({
                ...section,
                courseId: batchCourse.id,
                courseType: batchCourse.itemType,
            })));
            return;
        }
        // typing on turns it back into a new batch, so the course that name forced on us has to go
        if (courseCameFromClash.current) {
            courseCameFromClash.current = false;
            setSections(prevSections => prevSections.map(section => ({
                ...section,
                courseId: null,
                courseType: '',
            })));
        }
    }, [isJoiningExistingBatch, nameClash, autocompleteCoursesSearchData]);

    useEffect(() => {
        if (!fromCourseDetails) {
            if (!addSectionDrawer && !createBatchDrawer && selectedClassDetails?.length) { // addCourseDrawer handles automatically
                const updatedSections = selectedClassDetails.map((classDetail, idx) => {
                    const formatTime = (time) => time ? moment(time, "HH:mm:ss").format("hh:mm A") : "";
                    const daySelections = {
                        "2,3,4,5,6": "Mon-Fri",
                        "2,3,4,5,6,7": "Mon-Sat",
                        "1,2,3,4,5,6,7": "Mon-Sun",
                        "1,7": "Sat-Sun",
                    };
                    const sortedDays = (classDetail.days || []).sort((a, b) => a - b).join(",");
                    const repeat = daySelections[sortedDays] || "Custom";
                    return {
                        id: classDetail?.id,
                        index: idx + 1,
                        name: classDetail?.section,
                        startDate: classDetail?.startDate || "",
                        endDate: classDetail?.endDate && classDetail?.endDate != '0000-00-00' ? classDetail?.endDate : "",
                        startTime: formatTime(classDetail?.startTime),
                        endTime: formatTime(classDetail?.endTime),
                        repeat,
                        strength: classDetail?.maxStrength || 0,
                        stopAdmission: classDetail?.stopAdmission,
                        isExpanded: selectedClassDetails?.length == 1 ? true : false,
                        courseId: autocompleteCoursesSearchData.filter(item => item.itemId == classDetail?.courseId)[0]?.id,
                        courseType: "",
                        curriculum: classDetail?.alreadyImported == null || (classDetail.courseId !== classDetail.alreadyImported) ? false : true,
                        selectedDays: repeat === "Custom" ? new Set(classDetail.days || []) : new Set(),
                        studentsCount: classDetail?.studentsCount,
                        alreadyImported: classDetail?.alreadyImported
                    };
                });
                setSections(updatedSections);
                setClassName(selectedClassDetails[0]?.std)
            }
        } else {
            if (!addSectionDrawer1 && !createBatchDrawer1 && selectedClassDetails?.length) { // addCourseDrawer handles automatically
                const updatedSections = selectedClassDetails.map((classDetail, idx) => {
                    const formatTime = (time) => time ? moment(time, "HH:mm:ss").format("hh:mm A") : "";
                    const daySelections = {
                        "2,3,4,5,6": "Mon-Fri",
                        "2,3,4,5,6,7": "Mon-Sat",
                        "1,2,3,4,5,6,7": "Mon-Sun",
                        "1,7": "Sat-Sun",
                    };
                    const sortedDays = (classDetail.days || []).sort((a, b) => a - b).join(",");
                    const repeat = daySelections[sortedDays] || "Custom";
                    return {
                        id: classDetail?.id,
                        index: idx + 1,
                        name: classDetail?.section,
                        startDate: classDetail?.startDate || "",
                        endDate: classDetail?.endDate && classDetail?.endDate != '0000-00-00' ? classDetail?.endDate : "",
                        startTime: formatTime(classDetail?.startTime),
                        endTime: formatTime(classDetail?.endTime),
                        repeat,
                        strength: classDetail?.maxStrength || 0,
                        stopAdmission: classDetail?.stopAdmission,
                        isExpanded: selectedClassDetails?.length == 1 ? true : false,
                        courseId: autocompleteCoursesSearchData.filter(item => item.itemId == classDetail?.courseId)[0]?.id,
                        courseType: "",
                        curriculum: classDetail?.alreadyImported == null || (classDetail.courseId !== classDetail.alreadyImported) ? false : true,
                        selectedDays: repeat === "Custom" ? new Set(classDetail.days || []) : new Set(),
                        studentsCount: classDetail?.studentsCount,
                        alreadyImported: classDetail?.alreadyImported == null ? null : classDetail.courseId !== classDetail.alreadyImported ? null : classDetail.alreadyImported
                    };
                });
                setSections(updatedSections);
                setClassName(selectedClassDetails[0]?.std)
            }
        }


        if (!fromCourseDetails) {
            if (addSectionDrawer) {
                // When add section drawer is true, only set the class name
                // Keep the existing sections as they are
                setClassName(selectedClassDetails[0]?.std)
            }
        } else {
            if (addSectionDrawer1) {
                setClassName(selectedClassDetails[0]?.std)
            }
        }


    }, [selectedClassDetails]);


    // A new section belongs to the same course as the batch it is being added to, so start it there.
    // Waits on the autocomplete list, which is what maps the batch's courseId to the select's value.
    useEffect(() => {
        if (!addSectionDrawer && !addSectionDrawer1) {
            return;
        }
        // Not every section carries a course, so go by the first one that does.
        const batchCourseId = selectedClassDetails?.find(classDetail => classDetail?.courseId)?.courseId;
        const batchCourse = autocompleteCoursesSearchData.find(course => course.itemId == batchCourseId);
        if (!batchCourse) {
            return;
        }
        setSections(prevSections => prevSections.map(section => section.courseId ? section : ({
            ...section,
            courseId: batchCourse.id,
            courseType: batchCourse.itemType,
        })));
    }, [addSectionDrawer, addSectionDrawer1, selectedClassDetails, autocompleteCoursesSearchData]);


    useEffect(() => {
        if (sections.length == 1) {
            sections[0].isExpanded = true
        }
    }, [sections]);


    useEffect(() => {
        if (fromCourseDetails && isInsideSingleClass) {
            storeSectionId(selectedClassDetails[0]?.id)
        }
        getAutocompleteCourses(() => { });
    }, []);


    const deleteSection = (sectionId) => {
        if (sections.length > 1) {
            const updatedSections = sections
                .filter(section => section.index !== sectionId)
                .map((section, index) => ({
                    ...section,
                    index: index + 1 // Reindex the IDs to be sequential starting from 1
                }));
            // If we're deleting an expanded section and it's not the last one,
            // expand the next section or the last remaining section
            const wasExpandedDeleted = sections.find(s => s.index === sectionId)?.isExpanded;
            if (wasExpandedDeleted && updatedSections.length > 0) {
                const nextSection = updatedSections[updatedSections.length - 1];
                updatedSections.forEach(section => {
                    section.isExpanded = section.index === nextSection.index;
                });
            }
            if (updatedSections.length === 1) {
                updatedSections[0].isExpanded = true;
            }
            setSections(updatedSections);
        }
    };

    const toggleSection = (sectionId) => {
        setSections(sections.map(section => ({
            ...section,
            isExpanded: section.index === sectionId ? !section.isExpanded : section.isExpanded
        })));
    };

    const toggleDay = (dayValue, sectionIndex) => {
        setSections(sections.map((section, index) => {
            if (index === sectionIndex) {
                // Only update the selectedDays for the current section
                const newSelected = new Set(section.selectedDays);
                if (newSelected.has(dayValue)) {
                    newSelected.delete(dayValue);
                } else {
                    newSelected.add(dayValue);
                }
                return {
                    ...section,
                    selectedDays: newSelected
                };
            }
            return section;
        }));
    };

    const formatDateToDisplay = (date) => date ? moment(date, "YYYY-MM-DD").format("DD/MM/YYYY") : "";
    const formatDateToStore = (date) => date ? moment(date, "DD/MM/YYYY").format("YYYY-MM-DD") : "";

    // One course per batch, so the choice applies to every section.
    const handleCourseChange = (value) => {
        const selectedItem = filteredCourses.find(item => item?.id === value);
        setSections(sections.map(section => ({
            ...section,
            courseId: selectedItem?.id,
            courseType: selectedItem?.itemType,
            // Reset curriculum when course changes
            curriculum: false,
            alreadyImported: null,
        })));
    }
    // End date from the course duration (course module): start + duration - 1 day,
    // same as the course form. Returns "" when the duration isn't known.
    const getCourseEndDate = (startDate, sectionCourseId) => {
        const course = specificCourseDataContainer?.course;
        if (!fromCourseDetails || !course || !startDate) return "";
        // A section's courseId is the autocomplete option id; its itemId is the real course id.
        if (sectionCourseId && course?.id) {
            const option = (autocompleteCoursesSearchData || []).find((item) => String(item?.id) === String(sectionCourseId));
            const realCourseId = option?.itemId ?? sectionCourseId;
            if (String(realCourseId) !== String(course.id) && String(sectionCourseId) !== String(course.id)) return "";
        }
        const duration = parseInt(course?.duration, 10);
        const type = String(course?.durationType ?? "").trim().toLowerCase();
        const unit = (type.startsWith("day") || type === "1") ? "days"
            : (type.startsWith("month") || type === "30") ? "months"
            : (type.startsWith("year") || type === "360") ? "years"
            : null;
        if (!duration || duration <= 0 || !unit) return "";
        const end = moment(startDate, "YYYY-MM-DD").add(duration, unit).subtract(1, "days");
        return end.isValid() ? end.format("YYYY-MM-DD") : "";
    };

    const handleDateChange = (index, date, dateString, field) => {
        const updatedSections = [...sections];
        if (field === "startDate") {
            updatedSections[index][field] = formatDateToStore(dateString);
            // Autofill the end date from the course duration on every start date
            // change (still editable afterwards).
            const autoEndDate = getCourseEndDate(updatedSections[index][field], updatedSections[index]?.courseId);
            if (!updatedSections[index][field]) {
                // Start date cleared — clear the end date too (it's disabled until a start date is picked).
                updatedSections[index]["endDate"] = "";
            } else if (autoEndDate) {
                updatedSections[index]["endDate"] = autoEndDate;
            } else if (
                updatedSections[index]["endDate"] &&
                moment(updatedSections[index]["endDate"], "YYYY-MM-DD").isSameOrBefore(date, "day")
            ) {
                updatedSections[index]["endDate"] = ""; // Reset endDate
            }
        } else if (field === "endDate") {
            updatedSections[index][field] = formatDateToStore(dateString);
            // Reset startDate if it's after or the same as the new endDate
            // if (
            //     updatedSections[index]["startDate"] &&
            //     moment(updatedSections[index]["startDate"], "YYYY-MM-DD").isBefore(date, "day")
            // ) {
            //     updatedSections[index]["startDate"] = ""; // Reset startDate
            // }
        }
        setSections(updatedSections);
    };

    const handleTimeChange = (index, time, timeString, field) => {
        if (time) {
            const formattedTime = moment(time, "hh:mm A").format("hh:mm A"); // Convert to 12-hour format
            const updatedSections = [...sections];
    
            if (field === "startTime") {
                updatedSections[index][field] = formattedTime;
                updatedSections[index]["endTime"] = ""; // Clear endTime when startTime changes
            } else if (field === "endTime") {
                const startMoment = moment(updatedSections[index]["startTime"], "hh:mm A");
                const endMoment = moment(time, "hh:mm A");
    
                if (endMoment.isBefore(startMoment)) {
                    updatedSections[index]["endTime"] = ""; // Clear endTime if it's before startTime
                } else {
                    updatedSections[index][field] = formattedTime;
                }
            }
    
            setSections(updatedSections);
        }
    };

    const [onFocus, setOnFocus] = useState(false)
    const handleSelectChange = (value, sectionIndex) => {
        // Update the repeat value of the specific section
        const updatedSections = [...sections];
        updatedSections[sectionIndex].repeat = value; // Ensure this is correctly updating the repeat field
        setSections(updatedSections);
    };

    const daySelections = [
        { label: "Mon-Fri", value: "Mon-Fri" },
        { label: "Mon-Sat", value: "Mon-Sat" },
        { label: "Mon-Sun", value: "Mon-Sun" },
        { label: "Sat-Sun", value: "Sat-Sun" },
        { label: "Custom", value: "Custom" } // Custom will be handled dynamically
    ];

    const disabledEndTime = (section) => {
        if (!section.startTime) return {};
    
        const startMoment = moment(section.startTime, "hh:mm A");
        const startHour = startMoment.hour();
        const startMinute = startMoment.minute();
    
        return {
            disabledHours: () => [...Array(startHour).keys()], // Disable past hours
            disabledMinutes: (selectedHour) => {
                if (selectedHour === undefined) return [...Array(60).keys()]; // Disable all minutes until an hour is selected    
                return selectedHour === startHour
                    ? [...Array(startMinute + 1).keys()] // Disable past minutes when hour matches
                    : [];
            }
        };
    };


    // Add this function before the renderSectionContent
    const isCurrentSectionValid = (section) => {
        return section.name &&
            section.startDate &&
            section.startTime &&
            section.endTime &&
            section.repeat;
    };

    // Add this function to check if we can add more sections
    const canAddMoreSections = () => {
        // Get the last section (current section)
        const currentSection = sections[sections.length - 1];
        return isCurrentSectionValid(currentSection);
    };

    const moveSection = useCallback((dragIndex, hoverIndex) => {
        setSections((prevSections) => {
            if (prevSections.length === 1 || prevSections.some(section => section.isExpanded)) {
                return prevSections;
            }
            const newSections = [...prevSections];
            const draggedSection = newSections[dragIndex];
            newSections.splice(dragIndex, 1);
            newSections.splice(hoverIndex, 0, draggedSection);

            return newSections.map((section, idx) => ({
                ...section,
                index: idx + 1
            }));
        });
    }, []);


    const renderSectionContent = (section, index) => {
        const getButtonStyle = (isSelected) => ({
            width: '35px',
            height: '35px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: section.repeat === 'Custom' ? 'pointer' : 'default',
            border: 'none',
            backgroundColor: isSelected ? '#F3F3FF' : '#E6E6E6',
            color: isSelected ? '#594099' : '#AEAEAE',
            transition: 'background-color 0.2s, color 0.2s',
            fontWeight: 'bold',
            opacity: section.repeat === 'Custom' ? 1 : 0.6
        });



        return (<div className={`section-content ${section.isExpanded ? 'expanded' : ''}`} style={{ position: 'relative' }}>
            {
                sections.length > 1 &&
                <div className="section-header" >
                    <div
                        className="section-title"
                    >
                        {!section.isExpanded && section.name}
                    </div>
                    <div className="section-actions" style={{ position: 'absolute', right: 0, marginTop: !section.isExpanded ? -3 : 25 }}>

                        {sections.length > 1 && !sections.some(section => section.isExpanded) && (
                            <img
                                style={{ width: 16, height: 16, cursor: 'move' }}
                                src={enabledMove}
                            />
                        )}
                        {sections.length > 1 && !sections.some(section => section.isExpanded) && (
                            <DeleteOutlined
                                className="delete-icon"
                                onClick={(e) => {
                                    e.stopPropagation(); // Prevent section toggle
                                    if (section?.studentsCount > 0) {
                                        Notification.error("Error", 'Cannot delete a class with students!');
                                    } else {
                                        deleteSection(section.index);
                                    }
                                }}
                            />
                        )}
                        <div
                            style={{ cursor: 'pointer' }}
                            className="expand-icon"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                toggleSection(section.index);
                            }}
                        >
                            {section.isExpanded ? <img src={chevronDown} /> : <img src={chevronLeft} />}
                        </div>
                    </div>
                </div>
            }

            {section.isExpanded && (
                <div className="section-details" style={{ marginTop: !section.isExpanded ? 5 : createBatchDrawer || createBatchDrawer1 || addSectionDrawer || addSectionDrawer1 || sections.length == 1 ? 10 : -10 }}>
                    <AnimatedTextField
                        label="Section"
                        isMandatory={true}
                        inputId={`section-${index}`}
                        value={section.name}
                        handleInputChange={(e) => {
                            if (e.target.value.length > 3) return;
                            const updatedSections = [...sections];
                            updatedSections[index].name = e.target.value;
                            setSections(updatedSections);
                        }}
                    />

                    <div style={{ fontSize: 14, color: '#696969', fontWeight: 700, marginTop: 20 }}>Batch planning</div>

                    <div style={{ width: '100%', marginTop: 0, display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ width: '48%' }}>
                            <AnimatedDatePicker
                                inputReadOnly={true}
                                inputId={`${1000 + index}`}
                                label="Start date"
                                isMandatory={true}
                                value={formatDateToDisplay(section.startDate)}
                                handleDateChange={(date, dateString) => handleDateChange(index, date, dateString, "startDate")}
                                allowClear={true}
                            // disabledDate={(current) => section.endDate ?
                            //     current.isSameOrAfter(moment(section.endDate, "YYYY-MM-DD"), "day") : false}
                            />
                        </div>
                        <div style={{ width: '48%', opacity: section.startDate ? 1 : 0.5, transition: 'opacity 0.2s ease' }}
                            onClick={() => setOnFocus(prev => !prev)}

                        >
                            <AnimatedDatePicker

                                inputReadOnly={true}
                                label="End date"
                                // inputId={"0"}
                                // isMandatory={true}
                                value={formatDateToDisplay(section.endDate)}
                                handleDateChange={(date, dateString) => {
                                    handleDateChange(index, date, dateString, "endDate")
                                }}
                                allowClear={true}
                                disabledDate={(current) => section.startDate ?
                                    current.isBefore(moment(section.startDate, "YYYY-MM-DD"), "day") : false}
                                // Pick the start date first.
                                disabled={!section.startDate}
                                onFocus={onFocus}
                            />
                        </div>
                    </div>

                    <div style={{ width: '100%', marginTop: 10, display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ width: '48%' }}>
                            <AnimatedTimePicker
                                inputReadOnly={true}
                                inputId={`start-time-${index}`}
                                label="Start time"
                                isMandatory={true}
                                value={section.startTime ? moment(section.startTime, "hh:mm A") : null}
                                handleTimeChange={(time, timeString) => handleTimeChange(index, time, timeString, "startTime")}
                                allowClear={false}
                                format="hh:mm A"
                            />
                        </div>
                        <div style={{ width: '48%' }}>
                            <AnimatedTimePicker
                                inputReadOnly={true}
                                inputId={`end-time-${index}`}
                                label="End time"
                                isMandatory={true}
                                value={section.endTime ? moment(section.endTime, "hh:mm A") : null}
                                handleTimeChange={(time, timeString) => handleTimeChange(index, time, timeString, "endTime")}
                                allowClear={false}
                                format="hh:mm A"
                                disabled={!section.startTime}
                                disabledHours={disabledEndTime(section).disabledHours}
                                disabledMinutes={disabledEndTime(section).disabledMinutes}
                            />
                        </div>
                    </div>

                    <div style={{ width: '48%', marginTop: 20, cursor: 'pointer' }}>
                        <AnimatedCustomSelect
                            label="Class(es) repeat on"
                            required={true}
                            options={daySelections}
                            handleSelectChange={(value) => handleSelectChange(value, index)}
                            value={section.repeat}
                            isSelected={section.repeat ? true : false}
                        />
                    </div>

                    {section.repeat === 'Custom' && (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                            <div style={{ display: 'flex' }}><h2 style={{ fontSize: '12px', color: '#AEAEAE' }}>Select the days</h2> <span style={{ color: 'red', marginLeft: 3, marginBottom: 2, fontSize: 12 }}>*</span></div>

                            <div style={{ display: 'flex', gap: '8px' }}>
                                {days.map(({ label, value }) => (
                                    <button
                                        key={value}
                                        onClick={(e) => {
                                            if (section.repeat === 'Custom') {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                toggleDay(value, index);
                                            }
                                        }}
                                        style={getButtonStyle(section.selectedDays.has(value))}
                                        disabled={section.repeat !== 'Custom'}
                                    >
                                        {label}
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}

                    <div style={{ fontSize: 14, color: '#696969', fontWeight: 700, marginTop: 20 }}>
                        Additional information
                    </div>

                    <div style={{ width: '75%' }}>
                        <AnimatedTextField
                            label="Maximum student strength in this batch"
                            inputId={`strength-${index}`}
                            value={section.strength}
                            handleInputChange={(e) => {
                                const numericValue = e.target.value.replace(/\D/g, "");
                                if (numericValue !== "0") {
                                    const updatedSections = [...sections];
                                    updatedSections[index].strength = numericValue;
                                    setSections(updatedSections);
                                }
                            }}
                        />
                    </div>

                    <div style={{ marginTop: 20 }}>
                        <label style={{ color: '#636363' }}>
                            If maximum student strength in this batch reached?
                        </label>
                        <div style={{ marginTop: 10, display: 'flex' }}>
                            <input
                                type="radio"
                                checked={section.stopAdmission}
                                onChange={() => {
                                    const updatedSections = [...sections];
                                    updatedSections[index].stopAdmission = true;
                                    setSections(updatedSections);
                                }}
                            />
                            <label style={{ color: '#636363', marginLeft: 10 }}>Stop admissions</label>

                            <input
                                style={{ marginLeft: 80 }}
                                type="radio"
                                checked={!section.stopAdmission}
                                onChange={() => {
                                    const updatedSections = [...sections];
                                    updatedSections[index].stopAdmission = false;
                                    setSections(updatedSections);
                                }}
                            />
                            <label style={{ color: '#636363', marginLeft: 10 }}>Do not stop admissions</label>
                        </div>
                    </div>


                    {!((createBatchDrawer || createBatchDrawer1 || addSectionDrawer || addSectionDrawer1 || addCourseDrawer) && sections.length == 1) && <div
                        onClick={(e) => {
                            e.stopPropagation(); // Prevent section toggle
                            if (section?.studentsCount > 0) {
                                Notification.error("Error", 'Cannot delete a class with students!');
                            } else if (sections.length == 1 && !createBatchDrawer && !createBatchDrawer1 &&
                                !addSectionDrawer && !addSectionDrawer1 && !addCourseDrawer) {
                                setConfirmDeleteModal(true)
                            } else {
                                deleteSection(section.index);
                            }
                        }}
                        style={{ color: '#ff414d', display: 'flex', justifyContent: 'center', marginTop: 10, cursor: 'pointer' }}>
                        <DeleteOutlined
                            className="delete-icon"
                            style={{ height: 24, width: 24 }}

                        />
                        <span style={{ color: '#ff414d', marginLeft: 5, marginTop: 2, fontWeight: 600 }}>
                            DELETE
                        </span>
                    </div>}
                </div>
            )}
        </div>
        )
    };

    // Held while the name check is in flight, so an early submit cannot skip it.
    const isCreateDisabled = checkingName || sections.some(section =>
        !className ||
        !section.name ||
        !section.startDate ||
        !section.startTime ||
        !section.endTime ||
        (!fromCourseDetails && !section.courseId) ||
        !section.repeat ||
        (section.repeat === "Custom" && section.selectedDays.size === 0)
    );


    const handleYes = () => {
        const params = {
            std: className,
            oldStd: selectedClassDetails[0].std,
            isNew: false,
            standards: [],
            deletedStandardId: isInsideSingleClass ? selectedClassDetails[0].id : undefined,
            forAllSections: isInsideSingleClass ? "NO" : undefined,
        };
        // setAddClassLoader(true);
        console.log("fromCourseDetails",fromCourseDetails,isFromCourseDetailsReducer,editBatchModal1);
        
        postAddClassV2(
            params,
            () => { setAddClassLoader(false) },
            () => {
                onClose()
                if (fromCourseDetails) {
                    getAllClasses(newCourseId);
                    // deleted from the course page's batch list: the course is still there, so stay on it
                    const stayOnCoursePage = !isInsideSingleClass && history.location.pathname === "/course-details";
                    if (stayOnCoursePage) {
                        return;
                    }
                    if (fromCourseDetails && isFromCourseDetailsReducer) {
                        history.push("/course-details");
                    } else if(fromCourseDetails && editBatchModal1) {
                        history.push("/classroom");
                        // history.push("/course-details"); deleted for singleClassSection 

                    }
                    else {
                        history.push("/classroom");
                    }

                } else {
                    getAllClasses();
                }

            }
        );
    }

    const handleCreateBatch = () => {

        const dayMapping = { Sun: "1", Mon: "2", Tue: "3", Wed: "4", Thu: "5", Fri: "6", Sat: "7" };

        const convertTo24HourFormat = (time) => {
            const [hour, minute, period] = time.match(/(\d+):(\d+) (AM|PM)/).slice(1);
            let hours = parseInt(hour, 10);
            if (period === "PM" && hours !== 12) hours += 12;
            if (period === "AM" && hours === 12) hours = 0;
            return `${hours.toString().padStart(2, '0')}:${minute}:00`;
        };

        const transformedData = sections.map(item => {
            const { name, strength, repeat, startTime, endTime, selectedDays, ...rest } = item;
            let days
            // Convert repeat to days array
            if (repeat === 'Custom') {
                days = Array.from(selectedDays).map(String)
            } else {
                const dayOrder = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
                const [start, end] = repeat.split("-");
                if (dayMapping[start] && dayMapping[end]) {
                    const startIndex = dayOrder.indexOf(start);
                    const endIndex = dayOrder.indexOf(end);
                    days = dayOrder.slice(startIndex, endIndex + 1).map(day => dayMapping[day]);
                }
            }
            // Use section-specific selectedDays
            return {
                ...rest,
                section: name,
                maxStrength: parseInt(strength, 10),
                startTime: convertTo24HourFormat(startTime),
                endTime: convertTo24HourFormat(endTime),
                days
            };
        });

        const updatedTransformedData = transformedData.map(section => {
            return {
                ...section,
                courseId: resolveCourseId(section.courseId),
                // The import is no longer optional, so the curriculum always comes across.
                curriculum: true
            };
        });


        const params = {
            std: className,
            oldStd: createBatchDrawer || createBatchDrawer1 ? className : selectedClassDetails[0].std,
            isNew: !fromCourseDetails ? createBatchDrawer || addSectionDrawer || addCourseDrawer ? true : false
                : isInsideSingleClass || createBatchDrawer1 || addSectionDrawer1 ? true :
                    false,
            standards: updatedTransformedData,
            forAllSections: isInsideSingleClass ? "NO" : undefined,
        };
        const save = (extraParams = {}) => {
        setAddClassLoader(true);
        postAddClassV2(
            { ...params, ...extraParams },
            () => { setAddClassLoader(false) },
            (response) => {
                // Create linkArray based on curriculum being true
                const linkArray = updatedTransformedData
                    .filter(item => item.curriculum && !item.alreadyImported) // Only sections where curriculum is true
                    .map(item => ({
                        standardId: response.newStandards.length === 0
                            ? item.id
                            : response.newStandards.find(std => std.section === item.section)?.id,
                        courseId: item.courseId
                    }))
                    .filter(item => item.standardId && item.courseId); // Remove invalid entries
                if (linkArray.length > 0) {
                    postAddClassWithImport(linkArray);
                }
                onClose()
                if (fromCourseDetails && isInsideSingleClass) {

                    getSubjStudentsData((courseId) => {
                        if (courseId) {
                            getCourseData();
                        } else {
                            null
                        }
                    });
                }
                if (fromCourseDetails) {
                    getAllClasses(newCourseId);
                    if (fromCourseDetails && !isInsideSingleClass) {
                        setIsBatchesExpandClicked(true)
                    }
                } else {
                    getAllClasses();
                }


            }
        );
        };

        // A new section joining an existing batch whose other sections have no course: those take this
        // section's course too (curriculum and student enrolment with it), so ask first.
        const newCourseIds = [...new Set(updatedTransformedData.map(section => section.courseId).filter(Boolean))];
        const courselessSections = isCreatingNewBatch && newCourseIds.length === 1
            ? (nameClashSections || []).filter(section => section?.id && !section?.courseId)
            : [];
        if (!courselessSections.length) {
            save();
            return;
        }
        const courseName = autocompleteCoursesSearchData.find(course => course.itemId == newCourseIds[0])?.name?.replace(/ - [^-]*$/, '');
        Modal.confirm({
            title: `Assign ${courseName ? `"${courseName}"` : "this course"} to the rest of ${className}?`,
            content: `${courselessSections.length > 1 ? `Sections ${courselessSections.map(section => section.section).join(', ')} of this batch have` : `Section ${courselessSections[0].section} of this batch has`} no course. They will be assigned the same course, get its curriculum, and their students will be enrolled in it.`,
            okText: "Assign and create",
            cancelText: "Cancel",
            onOk: () => save({ assignCourseToCourselessSections: true }),
        });
    };

    return (
        <>
            <Drawer
                visible={fromCourseDetails ? editBatchModal1 : editBatchModal}
                onClose={onClose}
                width="500px"
                placement="right"
                closable={false}
            >
                <div style={{ height: '100%' }}>

                    <div className='scroll-bar-universal'

                        style={{
                            position: 'relative',
                            height: '92%',
                            paddingBottom: '80px',
                        }}>
                        <div className='batch-drawer-headline'>
                            <div className='batch-drawer-header'>
                                {!fromCourseDetails ? createBatchDrawer ? 'Create new batch' : addSectionDrawer ? 'Add sections' : 'Edit batch' : createBatchDrawer1 ? 'Create new batch' : addSectionDrawer1 ? 'Add sections' : 'Edit batch'}
                            </div>
                            <div onClick={onClose}>
                                <img src={Xmark} style={{ color: '#AEAEAE', fontWeight: 700, cursor: 'pointer', marginRight: 20, height: 15, width: 15 }} />
                            </div>
                        </div>

                        <div className='batch-drawer-mandatory'>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{ fontSize: 14, color: '#696969', fontWeight: 700 }}>
                                    Mandatory information
                                </div>
                                {/* {sections.length == 1 && !createBatchDrawer && !createBatchDrawer1 &&
                                    !addSectionDrawer && !addSectionDrawer1 && !addCourseDrawer && <div>
                                        <DeleteOutlined
                                            className="delete-icon"
                                            onClick={(e) => {
                                                e.stopPropagation(); // Prevent section toggle
                                                if (sections[0]?.studentsCount > 0) {
                                                    Notification.error("Error", 'Cannot delete a class with students!');
                                                } else {
                                                    // deleteSection(sections[0].index);
                                                    setConfirmDeleteModal(true)
                                                }
                                            }}
                                        />
                                    </div>} */}
                            </div>

                            <div>
                                <AnimatedTextField
                                    label="Batch name"
                                    isMandatory={true}
                                    inputId="batch-name"
                                    value={className}
                                    handleInputChange={(e) => setClassName(e.target.value)}
                                    isDisabled={addSectionDrawer || addSectionDrawer1}
                                    // the field is disabled anyway, but its inline colour hides that
                                    inputstyle={(addSectionDrawer || addSectionDrawer1) ? { color: '#AEAEAE' } : {}}
                                />
                                {nameClash &&
                                    <div style={{ color: '#636363', fontSize: 12, marginTop: 4 }}>
                                        This batch already exists{nameClash.courseName ? ` on the course "${nameClash.courseName}"` : ''}.
                                        {/* from a course page the section keeps that course, so another course's batch can't take it */}
                                        {fromCourseDetails && nameClash.courseId && nameClash.courseId != newCourseId ? '' : ' The section below will be added to it.'}
                                    </div>}
                            </div>
                            {/* Shared like the batch name: every section belongs to the same course. */}
                            {!fromCourseDetails &&
                                <div style={{ marginTop: 20 }}>
                                    <AnimatedCustomSelect
                                        label={"Course"}
                                        required={true}
                                        options={filteredCourses}
                                        source={"CRM"}
                                        handleSelectChange={(value) => handleCourseChange(value)}
                                        value={sections?.[0]?.courseId}
                                        // a new section joins the batch's course, so it cannot be changed here
                                        disabled={addSectionDrawer || addSectionDrawer1 || (isJoiningExistingBatch && !!nameClash?.courseId)}
                                        isSelected={sections?.[0]?.courseId ? true : false} />
                                </div>
                            }
                            <DndProvider backend={HTML5Backend}>
                                <div className="sections-container" >
                                    {sections.map((section, index) => (


                                        <DraggableSection
                                            key={section.index}
                                            section={section}
                                            index={index}
                                            moveSection={moveSection}
                                            sections={sections}
                                        >
                                            <div
                                                className={`section-wrapper ${sections.length > 1 ? 'bordered' : ''}`}
                                                style={{ paddingBottom: section.isExpanded ? 20 : 0 }}
                                            >
                                                {renderSectionContent(section, index)}
                                            </div>
                                        </DraggableSection>
                                    ))}
                                </div>
                            </DndProvider>
                            {
                                (!addCourseDrawer && !isInsideSingleClass) &&
                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 25 }}>
                                    <div

                                        style={{
                                            color: "#1089FF",
                                            fontWeight: 'bold',
                                            cursor: canAddMoreSections() ? 'pointer' : 'not-allowed',
                                            opacity: canAddMoreSections() ? 1 : 0.5,

                                        }}
                                        onClick={() => {
                                            if (canAddMoreSections()) {
                                                addSection();
                                            }
                                        }}
                                    >
                                        <PlusCircleOutlined style={{ color: '#1089FF' }} />
                                        <span style={{ marginLeft: 5 }}>ADD MORE SECTION</span>
                                    </div>
                                </div>
                            }

                        </div>

                        <div style={{
                            display: 'flex',
                            gap: '190px',
                            marginTop: 40,
                            marginBottom: 20,
                            position: 'fixed',
                            bottom: 0,
                            width: '80%',
                            paddingLeft: 20,

                            // zIndex: 100
                        }}>
                            <Button type='cancel'
                                onClick={onClose}
                            >
                                CANCEL
                            </Button>
                            <Button
                                loading={addClassLoader}
                                type="primary"
                                onClick={handleCreateBatch}
                                disabled={isCreateDisabled}
                            >
                                {!fromCourseDetails ? createBatchDrawer ? 'CREATE' : 'UPDATE' : createBatchDrawer1 ? 'CREATE' : 'UPDATE'}
                            </Button>
                        </div>

                    </div>
                </div>
            </Drawer>
            {showConfirmDeleteModal &&
                <BatchDeleteModal
                    showConfirmDeleteModal={showConfirmDeleteModal}
                    setConfirmDeleteModal={setConfirmDeleteModal}
                    className={className}
                    sectionName={sections[0]?.name}
                    // the request deletes every saved section of the batch, not just the one left on screen
                    sectionCount={isInsideSingleClass ? 1 : (selectedClassDetails?.length || 1)}
                    handleYes={handleYes}
                />}
        </>
    )
}

const mapStateToProps = (state) => {
    const { autocompleteCoursesSearchData, newCourseId,isFromCourseDetailsReducer, specificCourseDataContainer } = state.courseManagement

    const { selectedClassDetails } = state.classRoom;
    const { courses } = state.course;
    return {
        autocompleteCoursesSearchData, courses, selectedClassDetails, newCourseId,isFromCourseDetailsReducer, specificCourseDataContainer
    }
}

const mapDispatchToProps = (dispatch) => ({
    postAddClassV2: (params, callBack, successCallBack) => dispatch(postAddClassV2(params, callBack, successCallBack)),
    getAutocompleteCourses: (callback) => dispatch(getAutocompleteCourses(callback)),
    postAddClassWithImport: (linkArray) => dispatch(postAddClassWithImport(linkArray)),
    getAllClasses: (id) => dispatch(getAllClasses(id)),
    getSubjStudentsData: (callBack) => dispatch(getSubjStudentsData(callBack)),
    getCourseData: () => dispatch(getCourseData()),
    storeSectionId: (val) => dispatch(storeSectionId(val)),
    checkBatchNameAvailability: (std, callBack) => dispatch(checkBatchNameAvailability(std, callBack)),
})

export default connect(mapStateToProps, mapDispatchToProps)(EditBatchDrawer); 